import React from "react";
import BannerImage from "./BannerImage";
import LeftImgRightText from "./LeftImgRightText";
import RightImgLeftText from "./RightImgLeftText";
import "../App.css";

const Carpark = () => {
  document.title = "Carpark SG";

  return (
    <div className="ui">
      <BannerImage
        title={"Carpark availability"}
        image={require("../assets/img/cp/gg1.jpg")}
      />

      <div className="marginTopBtm">
        <LeftImgRightText
          image={require("../assets/img/cp/cp1.png")}
          text={"carparksg"}
          obj={{
            title: "Succeed to plan, plan to succeed",
            desc: "Check for carpark lots before heading to destination",
            dl:
              "Toggle between each tab to find out what you need and make sure you have a parking lot before to that parking lot.",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/carparksg/id1460263050",
            android:
              "https://play.google.com/store/apps/details?id=cordova.devjo.carpark",
          }}
        />
      </div>

      <div className="altColor marginTopBtm">
        <RightImgLeftText
          image={require("../assets/img/cp/cp2.png")}
          text={"carparksg"}
          obj={{
            title: "Interactive and Intuitive",
            desc: "Pinch and swipe to find out more through map",
            dl:
              "Click on pins to find out how many parking lots that your destination parking lots has left.",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/carparksg/id1460263050",
            android:
              "https://play.google.com/store/apps/details?id=cordova.devjo.carpark",
          }}
        />
      </div>

      <div className="marginTopBtm">
        <LeftImgRightText
          image={require("../assets/img/cp/cp3.png")}
          text={"carparksg"}
          obj={{
            title: "Parking in HDB estate",
            desc: "Search for HDB estate name to find out more",
            dl:
              "All the information available are last updated within minutes. Accuracy is almost 99%.",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/carparksg/id1460263050",
            android:
              "https://play.google.com/store/apps/details?id=cordova.devjo.carpark",
          }}
        />
      </div>

      <div className="altColor marginTopBtm">
        <RightImgLeftText
          image={require("../assets/img/cp/cp4.png")}
          text={"carparksg"}
          obj={{
            title: "Shopping in a mall",
            desc:
              "Find out how many parking lots your favourite shopping place has.",
            dl:
              "List of major Singapore shopping malls parking lots. Search the name of the shopping mall for more information.",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/carparksg/id1460263050",
            android:
              "https://play.google.com/store/apps/details?id=cordova.devjo.carpark",
          }}
        />
      </div>

      <div className="marginTopBtm">
        <LeftImgRightText
          image={require("../assets/img/cp/cp5.png")}
          text={"carparksg"}
          obj={{
            title: "More Information",
            desc: "Want to know where is free during weekend or late-night?",
            dl:
              "Search for your favourite supper or weekend hangout and see which nearby parking lots provides free parking when you are chilling.",
          }}
          links={{
            ios: "https://apps.apple.com/us/app/carparksg/id1460263050",
            android:
              "https://play.google.com/store/apps/details?id=cordova.devjo.carpark",
          }}
        />
      </div>
    </div>
  );
};

export default Carpark;
